import React from 'react';
import PropTypes from 'prop-types';
import {
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
  IconTooltip,
} from '@saucelabs/sl-component-form';

const FormSelect = ({
  feedback,
  formStyles,
  help,
  input,
  label,
  meta,
  onChange,
  options,
  placeholder,
  showErrorsWithoutSubmit,
  succeeded,
  ...props
}) => {
  const shouldShowTooltip = (
    showErrorsWithoutSubmit && !meta.pristine && meta.touched
  ) || meta.submitFailed;
  const validityMessage = meta.error || meta.submitError || null;
  const validityType = (
    shouldShowTooltip && (
      ((meta.error || meta.submitError) && 'error') ||
      (succeeded && 'success')
    )
  ) || null;

  let rightAddon = null;
  if (validityType && shouldShowTooltip) {
    rightAddon = (
      <IconTooltip
        message={validityMessage}
        type={validityType}
      />
    );
  } else if (!validityType && feedback) {
    rightAddon = (
      <FormControl.Feedback>
        <label htmlFor={input.name}>{feedback}</label>
      </FormControl.Feedback>
    );
  }

  const handleChange = (value) => {
    input.onChange(value);
    if (onChange) {
      onChange(value);
    }
  };

  const formControl = (
    <FormControl
      componentClass="select"
      {...props}
      {...input}
      onChange={handleChange}
    >
      <option value="">{placeholder || 'Select'}</option>
      {options.map(({ key, text, value }) => (
        <option
          key={key || text.replace(/\W/g, '')}
          value={value}
        >
          {text}
        </option>
      ))}
    </FormControl>
  );

  return (
    <FormGroup
      className={formStyles}
      controlId={input.name}
      validationState={validityType}
    >
      {label && (
        <ControlLabel htmlFor={input.name}>
          {label}
        </ControlLabel>
      )}
      {formControl}
      {rightAddon}
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
};

FormSelect.propTypes = {
  feedback: PropTypes.node,
  formStyles: PropTypes.string,
  help: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
  }),
  label: PropTypes.string,
  meta: PropTypes.object,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  showErrorsWithoutSubmit: PropTypes.bool,
  succeeded: PropTypes.bool,
};

FormSelect.defaultProps = {
  feedback: null,
  formStyles: '',
  help: null,
  input: {
    name: '',
    onChange: () => {},
  },
  label: null,
  meta: {
    error: null,
  },
  onChange: () => {},
  placeholder: '',
  showErrorsWithoutSubmit: false,
  succeeded: false,
};

export default FormSelect;
export { FormSelect };
